import { render, staticRenderFns } from "./MedicalMedications.vue?vue&type=template&id=5b688ec3&scoped=true"
import script from "./MedicalMedications.vue?vue&type=script&lang=js"
export * from "./MedicalMedications.vue?vue&type=script&lang=js"
import style0 from "./MedicalMedications.vue?vue&type=style&index=0&id=5b688ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b688ec3",
  null
  
)

export default component.exports